import React from "react";

const Logo = () => {
    return <span className="logo">MMI</span>;
};

export default Logo;
